import {
  TRACK_POINT_RADIUS,
  TRACK_POINT_LINE_WIDTH,
  TRACK_LINE_WIDTH,
} from '@/constants'

/**
 * 初期 state 取得
 * @returns {Object}
 */
const getDefaultState = () => ({
  showPoint: true,
  showLine: true,
  showStart: true,
  showEnd: true,
  pointRadius: TRACK_POINT_RADIUS.LARGE,
  pointLineWidth: TRACK_POINT_LINE_WIDTH.LARGE,
  lineWidth: TRACK_LINE_WIDTH.LARGE,
})

export default {
  namespaced: true,
  state: getDefaultState(),
  persistentStates: Object.keys(getDefaultState()),
  mutations: {
    /**
     * stateを初期化する
     * @param {*} state
     */
    resetState(state) {
      Object.assign(state, getDefaultState())
    },
    /**
     * 即位地点表示フラグを設定
     * @param {*} state
     * @param {Boolean} value 表示フラグ
     */
    setShowPoint(state, value) {
      state.showPoint = value
    },
    /**
     * 即位軌跡表示フラグを設定
     * @param {*} state
     * @param {Boolean} value 表示フラグ
     */
    setShowLine(state, value) {
      state.showLine = value
    },
    /**
     * 測位始点表示フラグを設定
     * @param {*} state
     * @param {Boolean} value 表示フラグ
     */
    setShowStart(state, value) {
      state.showStart = value
    },
    /**
     * 測位終点表示フラグを設定
     * @param {*} state
     * @param {Boolean} value 表示フラグ
     */
    setShowEnd(state, value) {
      state.showEnd = value
    },
    /**
     * 測位地点アイコンの半径を設定する
     * @param {*} state
     * @param {Number} value 測位地点半径
     */
    setPointRadius(state, value) {
      state.pointRadius = value
    },
    /**
     * 測位地点アイコンの太さを設定する
     * @param {*} state
     * @param {Number} value 測位地点の太さ
     */
    setPointLineWidth(state, value) {
      state.pointLineWidth = value
    },
    /**
     * 測位軌跡の太さを設定する
     * @param {*} state
     * @param {Number} value 測位軌跡の太さ
     */
    setLineWidth(state, value) {
      state.lineWidth = value
    },
  },
  getters: {
    /**
     * 測位地点表示フラグ
     * @param {*} state
     * @returns {Boolean}
     */
    showPoint: (state) => state.showPoint,
    /**
     * 測位軌跡表示フラグ
     * @param {*} state
     * @returns {Boolean}
     */
    showLine: (state) => state.showLine,
    /**
     * 測位始点表示フラグ
     * @param {*} state
     * @returns {Boolean}
     */
    showStart: (state) => state.showStart,
    /**
     * 測位終点表示フラグ
     * @param {*} state
     * @returns {Boolean}
     */
    showEnd: (state) => state.showEnd,
    /**
     * 測位地点アイコン半径
     * @param {*} state
     * @returns {Number|Null}
     */
    pointRadius: (state) => state.pointRadius,
    /**
     * 測位地点アイコンの太さ
     * @param {*} state
     * @returns {Number|Null}
     */
    pointLineWidth: (state) => state.pointLineWidth,
    /**
     * 測位軌跡の太さ
     * @param {*} state
     * @returns {Number|Null}
     */
    lineWidth: (state) => state.lineWidth,
    /**
     * 軌跡マップ設定に関するState
     * @param {*} state
     * @returns {Object}
     */
    settingState: (state) => {
      const {
        showPoint,
        showLine,
        showStart,
        showEnd,
        pointRadius,
        pointLineWidth,
        lineWidth,
      } = state
      return {
        showPoint,
        showLine,
        showStart,
        showEnd,
        pointRadius,
        pointLineWidth,
        lineWidth,
      }
    },
  },
  actions: {
    /**
     * 表示状態を設定する
     * @param {Array.<Object>} setting 表示状態
     */
    setSetting({ commit }, setting) {
      const {
        showPoint,
        showLine,
        showStart,
        showEnd,
        pointRadius,
        pointLineWidth,
        lineWidth,
      } = setting
      commit('setShowPoint', showPoint)
      commit('setShowLine', showLine)
      commit('setShowStart', showStart)
      commit('setShowEnd', showEnd)
      commit('setPointRadius', pointRadius)
      commit('setPointLineWidth', pointLineWidth)
      commit('setLineWidth', lineWidth)
    },
  },
}
